<template>
  <div class="service">
    <div id="textPC">
      <div id="situationPC">
        <a href="/"><img src="../assets/img/SMChatlogoPC.png" style="width: 116px;height: 116px;"></a>
        <img id="logoWord" src="../assets/img/SMChatlogo2PC.png" style="width: 183px;height: 43px;">
        <div id="textBox">
          <div id="textBoxTitle">服務條款<div id="hr"></div></div>
          <div id="textBoxContent"><serviceText/></div>
        </div>
      </div>
    </div>
    <div id="textMobile">
      <div id="situationMobile">
        <a href="/"><img src="../assets/img/SMChatlogoMobile.png" style="width: 90px;height: 90px;"></a>
        <img id="logoWord" src="../assets/img/SMChatlogo2Mobile.png" style="width: 140px;height: 33px;">
        <div id="textBox">
          <div id="textBoxTitle">服務條款<div id="hr"></div></div>
          <div id="textBoxContent"><serviceText/></div>
        </div>
      </div>
    </div>
    <navBar/>
    <background/>
  </div>
</template>
<script>
// @ is an alias to /src
import navBar from '@/components/navBar.vue'
import background from '@/components/background.vue'
import serviceText from '@/components/serviceText.vue'
export default {
  name: 'FAQ',
  components: {
    navBar,
    background,
    serviceText
  }
}
</script>
<style>
  @media screen and (max-width: 320px) {
    #textBox{
      width: 260px !important;
    }
  }
  @media screen and (max-width: 767px) {
    #textMobile{
      overflow: auto;
      height: calc(100vh - 202px);
    }
    #situationPC{ display: none; }
    #situationMobile{
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 56px;
    }
    #logoWord{ margin: 15px 0 25px 0 }
    #textBox{
      width: 313px;
      padding-top: 25px;
    }
    #textBoxTitle{
      font-size: 18px;
      line-height: 1.33;
      color: #413846;
      width: fit-content;
      height: 24px;
      margin: auto;
      margin-bottom: 30px;
    }
    #hr{
      height: 2px;
      background-color: black;
      margin-top: 7px;
    }
    #textBoxContent{
      font-size: 14px;
      line-height: 1.36;
      color: #413846;
      margin-bottom: 120px;
    }
  }
  @media screen and (min-width: 768px) {
    #situationMobile{ display: none;}
    #textPC{
      overflow: auto;
      height: calc(100vh - 77px);
    }
    #situationPC{
      margin-top: 11vh;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    #logoWord{ margin: 22px 0 46px 0 }
    #textBox{
      border-radius: 24px;
      border: solid 1px rgba(65, 56, 70, 0.2);
      width: 35vw;
      height: 41vh;
      background-color: white;
      padding: 33px 70px;
    }
    #textBoxTitle{
      width: fit-content;
      height: 32px;
      font-size: 24px;
      line-height: 1.33;
      color: #413846;
      margin: auto;
      margin-bottom: 32px;
    }
    #hr{
      height: 2px;
      background-color: black;
      margin-top: 7px;
    }
    #textBoxContent{
      font-size: 14px;
      line-height: 1.5;
      color: #413846;
      max-height: 83%;
      overflow: auto;
    }
  }
</style>
